import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const acmheadApi = createApi({
  reducerPath: 'acmheadApi',
  baseQuery: btBaseQuery,
  tagTypes: ['ACMHead'],

  endpoints: (builder) => ({
    getACMHeads: builder.query<ac_mhead[], string>({
      query: (cid) => `acmhead/${cid}`,
      providesTags: ['ACMHead']
    }),
    getACMHead: builder.query<ac_mhead, string>({
      query: (id) => `acmhead/byid/${id}`
    }),
    insertACMHead: builder.mutation({
      query: (acmhead) => ({
        url: `acmhead/`,
        method: 'POST',
        body: acmhead
      }),
      invalidatesTags: ['ACMHead']
    }),
    updateACMHead: builder.mutation({
      query: (acmhead) => ({
        url: `acmhead/`,
        method: 'PUT',
        body: acmhead
      }),
      invalidatesTags: ['ACMHead']
    }),
    deleteACMHead: builder.mutation({
      query: (acmhead) => ({
        url: `acmhead/${acmhead.ah_id}`,
        method: 'DELETE',
        body: acmhead
      }),
      invalidatesTags: ['ACMHead']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetACMHeadsQuery,
  useGetACMHeadQuery,
  useInsertACMHeadMutation,
  useUpdateACMHeadMutation,
  useDeleteACMHeadMutation
} = acmheadApi;
